var _a;
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    bypassChooser: false,
    isVoted: {},
};
export var extraSlice = createSlice({
    name: "extra",
    initialState: initialState,
    reducers: {
        setBypassChooser: function (state, action) {
            state.bypassChooser = action.payload;
            return state;
        },
        setIsVoted: function (state, action) {
            state.isVoted[action.payload] = true;
            return state;
        },
        clearIsVoted: function (state) {
            state.isVoted = {};
            return state;
        },
    },
});
export var setBypassChooser = (_a = extraSlice.actions, _a.setBypassChooser), setIsVoted = _a.setIsVoted, clearIsVoted = _a.clearIsVoted;
export var selectBypassChooser = function () { return function (state) { return state.extra.bypassChooser; }; };
export var isVotedByElectionId = function (electionId) { return function (state) {
    return electionId ? state.extra.isVoted[electionId] : false;
}; };
export default extraSlice.reducer;
